import { toast } from 'react-toastify';

export const notifySuccess = (message) => toast.success(message, {
  position: "bottom-left",
  autoClose: 4000,
  hideProgressBar: false,
});

export const notifyError = (message) => toast.error(message, {
  position: "bottom-left",
  autoClose: 4000,
  hideProgressBar: false,
});

export const notifyInfo = (message) => toast.info(message, {
  position: "bottom-left",
  autoClose: 4000,
  hideProgressBar: false,
});

export const notifyWarn = (message) => toast.warn(message, {
  position: "bottom-left",
  autoClose: 4000,
  hideProgressBar: false,
});